import AuthService from '@/service/auth/AuthService'
import PrefetchService from '@/service/auth/PrefetchService'

export default [{
  name: 'main',
  path: '/',
  beforeEnter(to, from, next) {
    if (AuthService.isSignin() === true) {
      // Prefetch
      let query = PrefetchService.filterQuery(to.query)
      if (query) {
        next()
      } else {
        next({ name: 'dashboard' })
      }
      return
    }
    next()
  },
  component: require('@/views/main/Main.vue').default
}]
